<template>

  <v-container fluid>
    <v-card class="elevation-2 pt-5 rounded-lg">
      <v-row class="px-6 py-0 my-0">
        <v-col cols="12" md="4" sm="12" xs="12" class="d-flex py-0 my-0 justify-start">
          <v-autocomplete
              v-model="selectedCampaign"
              :items="campaigns"
              item-text="name"
              item-value="id"
              label="Campaigns"
              outlined
              dense
              class="text-body-2 text-capitalize mx-0 my-0 pr-0 pb-0"
              @change="getSettings"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="5" class="d-flex py-0 mt-0 mb-5 justify-start">
          <v-dialog v-model="dialogSettings" persistent max-width="600px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  :disabled="!selectedCampaign"
                  class="ml-0 my-0 py-5 text-body-2 text-capitalize elevation-2"
                  v-bind="attrs"
                  v-on="on"
                  color="white"
              >
                Campaign settings
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Settings</span>
              </v-card-title>
              <v-card-text class="pb-0">
                <v-container>
                  <v-row>
                    <v-col>
                      <v-text-field type="number" label="Sport First Ratio" v-model="settings.sportFirst"
                                    :disabled="!managementRight"></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field type="number" label="Max Sport First, $" v-model="settings.maxSportFirst"
                                    :disabled="!managementRight"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field type="number" label="Sport Top Ratio" v-model="settings.sportTop"
                                    :disabled="!managementRight"></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field type="number" label="Max Sport Top, $" v-model="settings.maxSportTop"
                                    :disabled="!managementRight"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field type="number" label="Sport First Page Ratio" v-model="settings.sportFirstPage"
                                    :disabled="!managementRight"></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field type="number" label="Max Sport First Page, $" v-model="settings.maxSportFirstPage"
                                    :disabled="!managementRight"></v-text-field>
                    </v-col>
                  </v-row>
                  <hr style="border-top: 1px dashed lightgray;"/>
                  <v-row>
                    <v-col>
                      <v-switch v-model="settings.cruiseControl" :disabled="!managementRight">
                        <template v-slot:label>
                          <div class="ml-1">Automated Cruise</div>
                        </template>
                      </v-switch>
                    </v-col>
                    <v-col>
                      <v-switch v-model="settings.isSilentModeMailing" :disabled="!managementRight">
                        <template v-slot:label>
                          <div class="ml-1">Exclude from Mailing</div>
                        </template>
                      </v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-show="settings.cruiseControl">
                    <v-col>
                      <v-text-field type="number" label="Count Sport First" v-model="settings.countSportFirst"
                                    :disabled="!managementRight"></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field type="number" label="Count Sport Top" v-model="settings.countSportTop"
                                    :disabled="!managementRight"></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field type="number" label="Count Sport First Page" v-model="settings.countSportFirstPage"
                                    :disabled="!managementRight"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-show="settings.cruiseControl">
                    <v-col>
                      <v-text-field type="number" label="Frequency Apply Rank (in days)"
                                    v-model="settings.dayAppliedRank" :disabled="!managementRight"></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field disabled label="Last Applied Rank"
                                    v-model="settings.lastAppliedRank"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row
                      class="fill-height"
                      align-content="center"
                      justify="center"
                      v-if="settingsLoaded"
                  >
                    <v-col cols="12">
                      <v-progress-linear
                          indeterminate
                          rounded
                          height="6"
                          :active="settingsLoaded"
                      ></v-progress-linear>
                    </v-col>
                    <v-col
                        class="text-caption text-center"
                        cols="12"
                    >
                      Settings are saving... Please wait
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancelSettings" :disabled="settingsLoaded">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="saveSettings" v-if="managementRight"
                       :disabled="settingsLoaded">Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogKeywords" persistent max-width="600px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-show="managementRight"
                     :disabled="!selectedCampaign"
                     class="ml-5 my-0 py-5 depressed text-body-2 text-capitalize elevation-2"
                     v-bind="attrs"
                     v-on="on"
                     color="white"
              >
                Add New Keywords
              </v-btn>
            </template>
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
            >
              <v-card>
                <v-card-title>
                  <span class="headline">Keywords</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-autocomplete
                            v-if="fullKeywordForm.id == null"
                            v-model="selectedAd"
                            :items="adGroups"
                            :rules="emptyRules"
                            required
                            item-text="name"
                            item-value="id"
                            label="Ad Group*"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-autocomplete
                            @blur="validate"
                            :rules="emptyRules"
                            v-model="selectedMatch"
                            :items="matchTypes"
                            required
                            item-text="name"
                            item-value="id"
                            label="Match Type"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <p>Available ads: <span>{{ adGroupSelect }}</span></p>
                    </v-row>
                    <v-row>
                      <v-textarea
                          filled
                          label="Keywords"
                          placeholder="keyword*; max cpc; daily budget"
                          auto-grow
                          :rules="rules"
                          v-model="fullKeywordForm.keywords"
                      ></v-textarea>
                    </v-row>
                  </v-container>
                  <small>*indicates required field</small>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="cancelKeywords">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="saveKeywords" :disabled="!valid">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
          <v-btn  href="/#/cruise-campaign" target="_blank" class="ml-5 my-0 py-5 depressed text-body-2 text-capitalize elevation-2">
            <v-icon>mdi-link-variant</v-icon> Batch view
          </v-btn>
        </v-col>
        <v-col cols="12" md="3" class="d-flex py-0 mt-0 mb-5 justify-start justify-md-end">
          <v-chip
              class="my-2"
              :color="hasIssueWithMode"
              label
              outlined
              v-if="selectedCampaign && !loadedSetting"
          >
            {{ campaignStatus }}
          </v-chip>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-1 px-6 mt-4 rounded-lg">
      <v-row class="pa-0">
        <v-col cols="12" md="3" sm="6">
          <b>Campaign Budget:</b> ${{ budgetCampaign }}
        </v-col>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-0 px-2 mt-4 rounded-lg" v-show="selectedCampaign">
      <v-row class="px-4 pb-0 pt-3">
        <v-col cols="4" class="pb-0">
          <v-text-field
              dense
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              outlined
          ></v-text-field>
        </v-col>
        <v-col cols="2" class="pb-0">
          <v-select v-model="filters.searchMatch" :items="['contains','equals']" outlined dense label="Search Match"></v-select>
        </v-col>
        <v-btn
            color="#3F51B5"
            class="mt-3"
            dark
            depressed
            height='40'
            max-width='40'
            min-width='40'
            @click="cleanFilters"
        >
          <v-icon>
            mdi-autorenew
          </v-icon>
        </v-btn>
      </v-row>
      <v-row class="px-7 pb-0 ">
        <v-col cols="12" sm="5" md="2" class="pa-0 mr-auto">
          <v-select
              dense
              v-model="filters.status"
              :items="statusFilter"
              :menu-props="{ maxHeight: '400' }"
              multiple
              outlined
              :class="{'v-input--is-focused primary--text' : filters.status.length}"
              @change="clearSelected"
          >
            <template v-slot:label>
              <p :class="filters.status.length ? 'primary--text' : ''">Status</p>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" sm="5" md="2" class="pa-0 mr-auto">
          <v-select
              dense
              v-model="filters.adGroupName"
              :items="adGroupNameFilter"
              :menu-props="{ maxHeight: '400' }"
              multiple
              outlined
              :class="['pa-0', {'v-input--is-focused primary--text' : filters.adGroupName.length}]"
              @change="clearSelected"
          >
            <template v-slot:label>
              <p :class="filters.adGroupName.length ? 'primary--text' : ''">Ad Group</p>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" sm="5" md="2" class="pa-0 mr-auto">
          <v-select
              dense
              v-model="filters.mode"
              :items="modeFilter"
              item-text="text"
              item-value="value"
              :menu-props="{ maxHeight: '400' }"
              label="Mode"
              multiple
              outlined
              :class="['pa-0', {'v-input--is-focused primary--text' : filters.mode.length}]"
              @change="clearSelected"
          >
            <template v-slot:label>
              <p :class="filters.mode.length ? 'primary--text' : ''">Keyword Mode</p>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" sm="5" md="2" class="pa-0 mr-auto">
          <v-select
              dense
              v-model="filters.position"
              :items="positionFilter"
              :menu-props="{ maxHeight: '400' }"
              multiple
              outlined
              :class="['pa-0', {'v-input--is-focused primary--text' : filters.position.length}]"
              @change="clearSelected"
          >
            <template v-slot:label>
              <p :class="filters.position.length ? 'primary--text' : ''">Current Position</p>
            </template>
          </v-select>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-1 px-0 mt-4 rounded-lg">
      <v-dialog v-model="dialogKeyword" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Keyword</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12" class="subtitle-1">
                  Keyword: {{ fullKeywordForm.text }}
                </v-col>
                <v-col cols="12" sm="12" md="12" class="subtitle-1">
                  Match Type: {{ fullKeywordForm.matchType || 'none' }}
                </v-col>
                <v-col cols="3" sm="3" md="3" class="max-cpc subtitle-1">
                  Max CPC *
                </v-col>
                <v-col cols="3" sm="3" md="3">
                  <v-text-field type="number"
                                required
                                outlined
                                dense
                                v-model="maxCpcEntire"
                                class="my-0 pa-0"
                                hide-details
                                :disabled="fullKeywordForm.mode == 'First' || fullKeywordForm.mode == 'Top' || fullKeywordForm.mode == 'First Page'"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-radio-group
                      label="Mode:"
                      v-model="fullKeywordForm.mode"
                      row
                      @change="editKeywordMode(fullKeywordForm.mode)"
                      class="my-0"
                  >
                    <v-radio
                        style="padding: 5px;"
                        label="Normal"
                        value="Normal"
                        :disabled="settings.cruiseControl != 0"
                    ></v-radio>
                    <v-radio
                        style="padding: 5px;"
                        label="Sport First"
                        value="First"
                        :disabled="settings.cruiseControl != 0"
                    ></v-radio>
                    <v-radio
                        style="padding: 5px;"
                        label="Sport Top"
                        value="Top"
                        :disabled="settings.cruiseControl != 0"
                    ></v-radio>
                    <v-radio
                        style="padding: 5px;"
                        label="Sport First Page"
                        value="FirstPage"
                        :disabled="settings.cruiseControl != 0"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <div v-if="fullKeywordForm.mode !== 'Normal'" class="d-flex">
                  <v-col cols="3" sm="3" md="3" class="max-cpc subtitle-1">
                    Ratio
                  </v-col>
                  <v-col cols="3" sm="3" md="3">
                    <v-text-field type="number"
                                  min="0.1"
                                  required
                                  outlined
                                  dense
                                  v-model="ratio"
                                  class="my-0 pa-0"
                                  hide-details
                    >
                    </v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" md="2">
                      <v-btn @click="overrideSettings">Set</v-btn>
                    </v-col>
                  <v-col cols="2" sm="2" md="2">
                    <v-btn @click="resetSettings">Reset</v-btn>
                  </v-col>
                </div>
                <v-col cols="12" sm="12" md="12" class="subtitle-1">
                  <div class="d-flex">
                    <p>Stopped</p>
                    <v-switch
                        v-model="fullKeywordForm.status"
                        false-value="Stopped"
                        true-value="Active"
                        @change="editKeywordStatus(fullKeywordForm.status)"
                        hide-details
                        class="mx-3 my-0 pt-2"
                    ></v-switch>
                    <p>Active</p>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="cancelKeyword">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="saveKeyword">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogHistory" max-width="500px">
        <v-card>
          <v-card-title>
            <span>History Changes</span>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">Date</th>
                  <th class="text-left">Hub Order Id</th>
                  <th class="text-left">Mode</th>
                  <th class="text-left">Sale Gallons</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in historyChanged" :key="item.date">
                  <td>{{ item.date }}</td>
                  <td>{{ item.hubOrderId }}</td>
                  <td>{{ item.mode }}</td>
                  <td>{{ item.gallons }}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-actions>
            <v-btn
                color="primary"
                text
                @click="dialogHistory = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogTotalCPC" persistent>
        <v-card height="auto">
          <v-card-title class="d-flex flex-column align-start">
            <span>Tracking CPC</span>
            <p class="text-subtitle-2">{{ selectedKeyword ? selectedKeyword.text : '' }}</p>
            <RangeFilter
                class="mb-7"
                :end="dateEndTotalCPC"
                :start="dateStartTotalCPC"
                @getDates="getDatesTotalCPC"
                :excludePeriod="excludePeriodCPC"
                :defaultPeriod="4"
            />
          </v-card-title>
          <v-card-text v-if="loadedTotalCPC">
            <p class="mt-4 text-center">Loading... Please wait</p>
            <v-progress-linear
                color="indigo"
                indeterminate
                rounded
                height="6"
            ></v-progress-linear>
          </v-card-text>
          <v-card-text v-else>
            <highcharts :options="chartOptionsAll" :updateArgs="updateArgs" style="height: 65vh"></highcharts>
          </v-card-text>
          <v-card-actions>
            <v-btn
                color="indigo white--text"
                text
                @click="closeCPC"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogTopCPC" persistent max-width="600px">
        <v-card>
          <v-card-title class="d-flex flex-column align-start">
            <span>Tracking Top CPC</span>
            <p class="text-subtitle-2">{{ selectedKeyword ? selectedKeyword.text : '' }}</p>
            <RangeFilter
                class="mb-7"
                :end="dateEndTopCPC"
                :start="dateStartTopCPC"
                @getDates="getDatesTopCPC"
                :excludePeriod="excludePeriodCPC"
                :defaultPeriod="4"
            />
          </v-card-title>
          <v-card-text v-if="loadedTopCPC">
            <p class="mt-4 text-center">Loading... Please wait</p>
            <v-progress-linear
                color="indigo"
                indeterminate
                rounded
                height="6"
            ></v-progress-linear>
          </v-card-text>
          <v-card-text v-else>
            <LineChart :chartData="topCPC"/>
          </v-card-text>
          <v-card-actions>
            <v-btn
                color="indigo white--text"
                text
                @click="closeCPC"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogFirstCPC" max-width="600px">
        <v-card>
          <v-card-title class="d-flex flex-column align-start">
            <span>Tracking First CPC</span>
            <p class="text-subtitle-2">{{ selectedKeyword ? selectedKeyword.text : '' }}</p>
            <RangeFilter
                class="mb-7"
                :end="dateEndFirstCPC"
                :start="dateStartFirstCPC"
                @getDates="getDatesFirstCPC"
                :excludePeriod="excludePeriodCPC"
                :defaultPeriod="4"
            />
          </v-card-title>
          <v-card-text v-if="loadedFirstCPC">
            <p class="mt-4 text-center">Loading... Please wait</p>
            <v-progress-linear
                color="indigo"
                indeterminate
                rounded
                height="6"
            ></v-progress-linear>
          </v-card-text>
          <v-card-text v-else>
            <LineChart :chart-data="firstCPC"/>
          </v-card-text>
          <v-card-actions>
            <v-btn
                color="indigo white--text"
                text
                @click="closeCPC"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card-title>
        <v-row class="pr-2 pl-6">
          <v-col cols="3" md="1" sm="2" class="pt-8 pb-0 px-0">
            <p class="text-body-2" v-if="managementRight">{{ selected.length }} selected </p>
          </v-col>
          <v-col cols="9" md="4" sm="10" class="pt-6 pb-0">
            <v-menu
                v-model="menuBulkEdit"
                :close-on-content-click="false"
                bottom
                offset-y
                :nudge-top="40"
                :max-width="350"
                v-if="managementRight"
                persistent
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    :disabled="selected.length == 0"
                    color="indigo white--text"
                    class="pa-5 text-body-2 text-capitalize elevation-2"
                    @click="cleanSelectedAction"
                >
                  Edit
                  <v-icon class="ml-1">
                    mdi-menu-down
                  </v-icon>
                </v-btn>
              </template>
              <v-dialog v-model="dialogConfirmBulkAction" persistent max-width="500px">
                <v-card>
                  <v-card-title>
                    <span class="headline">Confirmation</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        Are you sure you want to {{ selectedActionConfirmText }} {{ selected.length }} selected
                        keywords?
                      </v-row>
                      <div v-if="selectedAction == 'overrideSettings'">
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field type="number"
                                          min="0.1"
                                          placeholder="Custom Ratio"
                                          required
                                          outlined
                                          v-model="ratio"
                                          class="my-0 pa-0"
                                          hide-details
                            >
                            </v-text-field>
                          </v-col>
                      </div>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="cancelAction()"
                    >
                      No
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="applyAction()"
                      :disabled="selectedAction == 'overrideSettings' && ratio <= 0"
                    >
                      Yes
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-card>
                <v-list>
                  <v-list-item-group color="primary" v-model="selectedInxAction">
                    <v-list-item
                      v-for="(action, i) in bulkActions"
                      :key="i"
                      :disabled="action.disabled"
                      @click="selectAction(i)"
                    >
                      <v-list-item-icon class="mr-3">
                        <v-icon v-text="action.icon" :color="action.color"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-action v-text="action.text" class="ml-0 text-capitalize">
                      </v-list-item-action>
                    </v-list-item>
                  </v-list-item-group>
                  <v-divider class="mx-2"></v-divider>
                  <v-list-item-group color="primary" v-model="selectedInxModeAction">
                    <v-list-item
                      v-for="(action, i) in bulkModeActions"
                      :key="i"
                      :disabled="action.disabled"
                      @click="selectModeAction(i)"
                    >
                      <v-list-item-content>
                        <v-list-item-title v-text="action.text"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                  <v-divider class="mx-2"></v-divider>
                  <v-list-item-group v-model="selectedInxCPCAction">
                    <v-list-item
                      v-for="(action, i) in bulkCPCActions"
                      :key="i"
                      :disabled="action.disabled"
                    >
                      <v-list-item-content>
                        <v-list-item-title v-text="action.text"></v-list-item-title>
                        <v-list-item-action>
                          <v-row>
                            <v-col cols="4" class="pa-0 d-flex justify-start">
                              <v-text-field
                                type="number"
                                required
                                outlined
                                dense
                                v-model="maxCpcEntire"
                                class="pa-0"
                                prefix="$"
                                color="blue darken-1"
                                hide-details
                                :disabled="action.disabled"
                              >
                              </v-text-field>
                            </v-col>
                            <v-col cols="7" class="pa-0 d-flex justify-end">
                              <v-btn
                                color="blue darken-1"
                                text
                                height="40"
                                @click="cancelChangeCPC"
                                class="white--tex ml-1"
                                :disabled="action.disabled"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                color="blue darken-1"
                                text
                                height="40"
                                @click="selectChangeCPC"
                                class="white--tex"
                                :disabled="action.disabled || !maxCpcEntire"
                              >
                                Apply
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-list-item-action>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-menu>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="7" md="3" sm="9" class="d-flex justify-end pb-0 pt-0 mt-0">
            <v-spacer></v-spacer>
            <vue-excel-xlsx
              :data="dataFilteredForExcel"
              :columns="columnsData"
              :filename="`Cruise_Campaigns-${selectedCampaignName}`"
              :sheetname="`${createSheetName}`"
            >
              <v-btn
                height="39"
                min-width="39px"
                :disabled="data.length === 0"
                class="ml-auto mr-5 rounded-lg pa-0 ma-0"
                color="white"
              >
                <ExportExcel/>
              </v-btn>
            </vue-excel-xlsx>
            <CustomColumns
              :currentValue="value"
              :currentCustomHeader="customHeader"
              :currentHeaders="headers"
              :settingsName="settingsName"
              @getCustomData="getCustomData"
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-hover v-model="hoverOnTable" id="table-cruise-campaign">
        <v-card-text>
          <div class="d-flex justify-space-between">
            <v-btn
              class="mx-2 scroll-btn btn-left-arrow"
              fab
              small
              @click="scrollingLeft"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn
              class="mx-2 scroll-btn btn-right-arrow"
              fab
              small
              @click="scrollingRight"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-data-table
            :footer-props="{
              'items-per-page-options': [10, 25, 50, 75, 100, -1]
              }"
            fixed-header
            height="538px"
            v-model="selected"
            :headers="selectedHeaders"
            :items="data"
            item-key="uid"
            :show-select="managementRight"
            :loading="loaded"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :server-items-length="totalRows"
            :options.sync="optionsDataTable"
            loading-text="Loading... Please wait"
            id="datatable"
            class="elevation-0 table-main-container"
            @click:row="rowClick"
          >
            <template v-slot:header.totalCalls="{ header }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                </template>
                <div style="max-width: 400px">
                  Total Calls, which a keyword brought for the last 90 day
                </div>
              </v-tooltip>
            </template>
            <template v-slot:header.totalWebInq="{ header }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                </template>
                <div style="max-width: 400px">
                  Total Web Inquiries, which a keyword brought for the last 90 days
                </div>
              </v-tooltip>
            </template>
            <template v-slot:header.rank_keyword_campaign="{ header }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                </template>
                <div style="max-width: 400px">
                  Keyword rank within the campaign, calculated based on a proprietary formula to show the effectiveness of a keyword.
                </div>
              </v-tooltip>
            </template>
            <template v-slot:header.totalGallons="{ header }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                </template>
                <div style="max-width: 400px">
                  Total Gallons, which a keyword brought for the last 90 days
                </div>
              </v-tooltip>
            </template>
            <template v-slot:header.totalConversation="{ header }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                </template>
                <div style="max-width: 400px">
                  Total Conversions, which a keyword brought for the last 90 days
                </div>
              </v-tooltip>
            </template>
            <template v-slot:header.totalClicks="{ header }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                </template>
                <div style="max-width: 400px">
                  Total Clicks, which a keyword brought for the last 90 days
                </div>
              </v-tooltip>
            </template>
            <template v-slot:header.totalCost="{ header }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                </template>
                <div style="max-width: 400px">
                  Total Expenses for a keyword for the last 90 days.
                </div>
              </v-tooltip>
            </template>
            <template v-slot:header.firstCpc="{ header }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                </template>
                <div style="max-width: 400px">
                  This estimate approximates what cost-per-click (CPC) bid is needed for your ad to show in the first ad position at the top of search results when a search query exactly matches your keyword.
                </div>
              </v-tooltip>
            </template>
            <template v-slot:header.topCpc="{ header }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                </template>
                <div style="max-width: 400px">
                  The top of page bid estimate is the approximate cost-per-click bid you would need to make for your ad to show at the top of the first page of the search.
                </div>
              </v-tooltip>
            </template>
            <template v-slot:header.firstPageCpc="{ header }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                </template>
                <div style="max-width: 400px">
                  This estimate approximates what cost-per-click (CPC) bid is needed for your ad to show anywhere on the first page of search results when a search query exactly matches your keyword
                </div>
              </v-tooltip>
            </template>
            <template v-slot:header.createdAt="{ header }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                </template>
                <div style="max-width: 400px">
                  Date, when a keyword was created
                </div>
              </v-tooltip>
            </template>
            <template v-slot:item.mode="{ item }">
              <span v-if="item.mode == 'First'">Sport First</span>
              <span v-if="item.mode == 'Top'">Sport Top</span>
              <span v-if="item.mode == 'First Page'">Sport First Page</span>
              <span v-if="item.mode == 'Normal'">Normal</span>
            </template>
            <template v-slot:item.totalWebInq="{ item }">
              <a v-if="item.totalWebInq.length>0" @click="showSimpleAlert(item, 'web')">{{ item.totalWebInq.length }}</a>
              <span v-else>0</span>
            </template>
            <template v-slot:item.totalCalls="{ item }">
              <a v-if="item.totalCalls.length>0" @click="showSimpleAlert(item, 'call')">{{ item.totalCalls.length }}</a>
              <span v-else>0</span>
            </template>
            <template v-slot:item.rank_keyword_campaign="{ item }">
              <a v-if="item.rank_keyword_campaign>0 || item.rank_keyword_campaign<0 " @click="getRankHistory(item)">{{ item.rank_keyword_campaign }}</a>
              <span v-if="item.rank_keyword_campaign==0">0</span>
            </template>
            <template v-slot:item.movement="{ item }">
              <v-chip v-if="item.movement" :color="getColor(item.movement)">Up</v-chip>
            </template>
            <template v-slot:item.dailySpent="{ item }">
              <span v-if="item.dailySpent>0">$ {{ parseFloat(item.dailySpent / 1000000).toFixed(2) }}</span>
              <span v-if="item.dailySpent==0">0</span>
            </template>
            <template v-slot:item.dailyBudget="{ item }">
              <span v-if="item.dailyBudget>0">$ {{ parseFloat(item.dailyBudget / 1000000).toFixed(2) }}</span>
              <span v-if="item.dailyBudget==0">0</span>
            </template>
            <template v-slot:item.avgCpc="{ item }">
              <span v-if="item.avgCpc>0">{{ parseFloat(item.avgCpc / 1000000).toFixed(2) }}</span>
              <span v-if="item.avgCpc==0">0</span>
            </template>
            <template v-slot:item.totalOrders="{ item }">
              <span v-if="item.totalOrders>0"><a @click="openSaleReport(item.orderIds)">{{item.totalOrders}}</a></span>
              <span v-if="item.totalOrders==0">0</span>
            </template>
            <template v-slot:item.maxCpc="{ item }">
              <a v-if="item.maxCpc>0" @click="getAllCPC(item)">{{ parseFloat(item.maxCpc / 1000000).toFixed(2) }}</a>
              <span v-if="item.maxCpc==0">0</span>
            </template>
            <template v-slot:item.totalCost="{ item }">
              <span v-if="item.totalCost>0">$ {{
                  parseFloat(item.totalCost / 1000000).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}</span>
              <span v-if="item.totalCost==0">0</span>
            </template>
            <template v-slot:item.firstCpc="{ item }">
              <a v-if="item.firstCpc>0" @click="getFirstCPC(item)">{{
                  parseFloat(item.firstCpc / 1000000).toFixed(2)
                }}</a>
              <span v-if="item.firstCpc==0">0</span>
            </template>
            <template v-slot:item.topCpc="{ item }">
              <a v-if="item.topCpc>0" @click="getTopCPC(item)">{{ parseFloat(item.topCpc / 1000000).toFixed(2) }}</a>
              <span v-if="item.topCpc==0">0</span>
            </template>
            <template v-slot:item.firstPageCpc="{ item }">
              <a v-if="item.firstPageCpc>0" @click="getFirstPageCPC(item)">{{
                  parseFloat(item.firstPageCpc / 1000000).toFixed(2)
                }}</a>
              <span v-if="item.firstPageCpc==0">0</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="d-flex flex-column">
                <v-icon
                    small
                    v-if="managementRight"
                    @click.stop.prevent="edit(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                    small
                    class="mt-1"
                    @click.stop.prevent="getHistory(item)"
                >
                  mdi-history
                </v-icon>
              </div>
            </template>
          </v-data-table>
          <v-dialog v-model="dialogRankHistory" max-width="48%">
            <v-card>
              <v-card-title class="d-flex flex-column align-start">
                <span>Rank History</span>
                <div class="d-flex">
                  <p class="text-subtitle-2 mt-1">Keyword: {{ selectedKeyword ? selectedKeyword.text : '' }}</p>
                </div>
                <RangeFilter
                  class="mb-7 mt-3"
                  :end="dateEndHistory"
                  :start="dateStartHistory"
                  @getDates="getDatesHistory"
                  :excludePeriod="excludePeriod"
                  :defaultPeriod="6"
                />
              </v-card-title>
              <v-card-text v-if="loadedHistory">
                <p class="mt-4 text-center">Loading... Please wait</p>
                <v-progress-linear
                  color="indigo"
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
              </v-card-text>
              <v-card-text v-else>
                <apexchart :options="chartOptionsRankHistory" :series="seriesRankHistory"></apexchart>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="indigo white--text"
                  text
                  @click="closeHistory"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogSimple" max-width="38%">
            <v-card>
              <v-card-title class="d-flex flex-column align-start">
                <span v-if="dialogSimpleType == 'web'">Web Inquiries</span>
                <span v-else>Calls</span>
                <div class="d-flex">
                  <p class="text-subtitle-2 mt-1">Keyword: {{ selectedKeyword ? selectedKeyword.text : '' }}</p>
                </div>
              </v-card-title>
              <v-card-text>
                <div v-if="dialogSimpleType == 'web'">
                  <ul v-if="selectedKeyword">
                    <li v-for="item of selectedKeyword.totalWebInq" :key="item">{{item}}</li>
                  </ul>
                </div>
                <div v-else>
                  <ul v-if="selectedKeyword">
                    <li v-for="item of selectedKeyword.totalCalls" :key="item">
                      <a target="_blank" :href="`https://app.callrail.com/calls/${item.toString().trim()}`">{{item}}</a>
                    </li>
                  </ul>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="indigo white--text"
                  text
                  @click="dialogSimple = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-text>
      </v-hover>
    </v-card>
  </v-container>
</template>

<script>
import {default as maths} from '@/utils/maths'
import axios from '@/api/axios-auth'
import LineChart from '@/utils/charts/LineChart'
import RangeFilter from '@/components/filters/RangePicker'
import CustomColumns from '@/components/customizing/CustomColumns'
import ExportExcel from '@/components/customizing/ExportExcel'
import _ from 'lodash'
import moment from 'moment'
import {Chart} from 'highcharts-vue'

maths()

export default {
  name: 'keywords',
  components: {
    LineChart,
    RangeFilter,
    CustomColumns,
    ExportExcel,
    highcharts: Chart
  },
  data() {
    let self = this
    return {
      updateArgs: [true, true, true],
      chartOptionsAll: {
        chart: {
          zoomType: 'xy'
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
        },
        tooltip: {
          shared: true,
        },
        xAxis: {
          labels: {
            formatter: function() {
                return moment(new Date(this.value)).format('MM/DD/YYYY')
            },
          },
          gridLineWidth: 1,
          categories: [],
          type: 'datetime',
          plotBands: []
        },
        yAxis: [{ // Primary yAxis
          labels: {
            format: '{value}',
            style: {
              color: '#43A357'
            }
          },
          title: {
            text: 'CPC, $',
            style: {
              color: '#43A357'
            }
          }
        }, { // Secondary yAxis
          left: 30,
          title: {
            text: 'Metric (0-1)',
            style: {
              color: '#586ACE'
            }
          },
          min: 0,
          max: 1,
          labels: {
            format: '{value}',
            style: {
              color: '#586ACE'
            }
          },

          opposite: true
        }, { // Secondary yAxis
          left: 30,
          title: {
            text: 'Value (Click, Impr, Conv)',
            style: {
              color: '#586ACE'
            }
          },
          min: 0,
          labels: {
            format: '{value}',
            style: {
              color: '#586ACE'
            }
          },

          opposite: true
        },
        { // Secondary yAxis
          left: 30,
          title: {
            text: 'Rank',
            style: {
              color: '#586ACE'
            }
          },
          min: 0,
          labels: {
            format: '{value}',
            style: {
              color: '#586ACE'
            }
          },

          opposite: true
        }],
        series: []
      },
      statusFilter: ["Active", "Stopped", "Removed"],
      positionFilter: ["First", "Top", "First Page", "NA"],
      modeFilter: [
        {text: 'Sport First ', value: 'First'},
        {text: 'Sport Top ', value: 'Top'},
        {text: 'Sport First Page', value: 'First Page'},
        {text: 'Normal ', value: 'Normal'},
        ],
      adGroupNameFilter: [],
      totalRows: 0,
      sortBy: '',
      sortDesc: '',
      dragging: false,
      settings: {
        sportFirst: 0,
        maxSportFirst: 0,
        sportTop: 0,
        maxSportTop: 0,
        countSportFirst: 0,
        countSportTop: 0,
        cruiseControl: false,
        dayAppliedRank: 0,
        lastAppliedRank: 0
      },
      menuBulkEdit: false,
      selectedInxAction: null,
      selectedInxModeAction: null,
      selectedInxCPCAction: null,
      dialogConfirmBulkAction: false,
      selectedActionConfirmText: '',
      bulkActions: [
        {text: 'Enable Keyword', value: 'resume', icon: 'mdi-play-circle', color: 'green', confirmation: 'enable'},
        {text: 'Pause Keyword', value: 'pause', icon: 'mdi-pause-circle', color: 'grey', confirmation: 'pause'}
      ],
      bulkModeActions: [
        {text: 'Sport First Mode', value: 'SportFirstMode', confirmation: 'set Sport First Mode for'},
        {text: 'Sport Top Mode', value: 'SportTopMode', confirmation: 'set Sport Top Mode for'},
        {text: 'Sport First Page Mode', value: 'SportFirstPageMode', confirmation: 'set Sport First Page Mode for'},
        {text: 'Normal Mode', value: 'normal', confirmation: 'set Normal Mode for'},
        {text: 'Set Ratio', value: 'overrideSettings', confirmation: 'set rank for'},
        {text: 'Reset Ratio', value: 'resetSettings', confirmation: 'reset rank for'},
      ],
      bulkCPCActions: [
        {text: 'Change Max CPC', value: 'changeMaxCpc'}
      ],
      valid: true,
      emptyRules: [
        v => !!v || 'Field is required',
      ],
      rules: [
        v => !!v || 'Field is required',
        v => (v || '').indexOf(',') === -1 || 'It is forbidden to use a comma (,). Use (;) for split or (.) for number',
        v => {
          if (v === null) {
            return true
          }

          let keywords = []
          let lines = v.split("\n")
          for (let l of lines) {
            let parts = l.split(";")
            let keyword = parts[0].trim()
            const ukey = this.makeUnicKeyForKeywored(keyword, '','' );
            if(this.kywordsUnicKeys.has(ukey))
            {
              keywords.push(keyword)
            }
          }

          if (keywords.length == 0) {
            return true
          }

          return "Duplicates keyword and selected match type: " + keywords
        }
      ],
      selectedAction: '',
      selectedActionAtEdit: '',
      selectedStatusAtEdit: '',
      showRequiredColumns: false,
      search: '',
      filters: {
        'searchMatch': 'contains',
        'status': ['Active'],
        'adGroupName': [],
        'position': [],
        'mode': [],
        'labels': []
      },
      dialogKeyword: false,
      dialogKeywords: false,
      dialogHistory: false,
      dialogTotalCPC: false,
      dialogTopCPC: false,
      dialogFirstCPC: false,
      dialogSettings: false,
      dialogCustomColumns: false,
      totalCPC: {},
      topCPC: {},
      firstCPC: {},
      options: {
        responsive: true,
        maintainAspectRatio: false
      },
      optionsDataTable: {},
      dateEnd: new Date().toISOString().substr(0, 10),
      dateStart: new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              1)).toISOString().substr(0, 10),
      excludePeriod: [],
      defaultPeriod: 5,
      itemCPC: {
        adGroupId: null,
        id: null
      },
      hideAnything: false,
      selected: [],
      selectedTmp: [],
      selectedAd: 0,
      campaigns: [],
      maxCpcEntire: null,
      ratio: 1,
      selectedCampaign: null,
      statisticForCurrentDay: {
        totalSpentDay: 0,
        totalCalls: 0,
        totalClicks: 0
      },
      historyChanged: [],
      fullKeywordForm: {
        text: '',
        maxCpc: null,
        dailyBudget: null,
        keywords: null,
        movement: ''
      },
      settingsName: 'cruiseCampaigns',
      headers: [
        {text: 'Actions', value: 'actions', class: 'black--text', sortable: false},
        {text: 'Status', value: 'status', class: 'black--text'},
        {text: 'Rank K/C', value: 'rank_keyword_campaign', class: 'black--text'},
        {text: 'Total Gallons K/C', value: 'totalGallons', class: 'black--text'},
        {text: 'Keyword', value: 'text', class: 'black--text'},
          {text: 'Potential Gallons K/C', value: 'p_gallons', class: 'black--text'},

        {text: 'Match Type', value: 'matchType', class: 'black--text'},
        {text: 'Ad Group', value: 'adGroupName', class: 'black--text'},
        {text: 'Position', value: 'position', class: 'black--text'},
        {text: 'Keyword Mode', value: 'mode', class: 'black--text'},
        {text: 'Max CPC', value: 'maxCpc', class: 'black--text'},
        {text: 'First CPC', value: 'firstCpc', class: 'black--text'},
        {text: 'Top CPC', value: 'topCpc', class: 'black--text'},
        {text: 'First Page CPC', value: 'firstPageCpc', class: 'black--text'},
        {text: 'Total Calls', value: 'totalCalls', class: 'black--text'},
        {text: 'Total Web Inquiries', value: 'totalWebInq', class: 'black--text'},
        {text: 'Expenses', value: 'totalCost', class: 'black--text'},
        {text: 'Total Orders', value: 'totalOrders', class: 'black--text'},
        {text: 'Total Conversions', value: 'totalConversation', class: 'black--text'},
        {text: 'Total Clicks', value: 'totalClicks', class: 'black--text'},
        {text: 'Total Impressions', value: 'totalImpressions', class: 'black--text'},
        {text: 'Quality Score', value: 'qualityScore', class: 'black--text'},
        {text: 'Ratio', value: 'ratio', class: 'black--text'},
        {text: 'Created Date', value: 'createdAt', class: 'black--text'},
      ],
      data: [],
      DateUpdateCache4Data:null,
      allCampaigns: [],
      value: [
        {text: 'Actions', value: 'actions', class: 'black--text'},
        {text: 'Status', value: 'status', class: 'black--text'},
        {text: 'Rank K/C', value: 'rank_keyword_campaign', class: 'black--text'},
        {text: 'Total Gallons K/C', value: 'totalGallons', class: 'black--text'},
        {text: 'Keyword', value: 'text', class: 'black--text'},
          {text: 'Potential Gallons K/C', value: 'p_gallons', class: 'black--text'},
        {text: 'Match Type', value: 'matchType', class: 'black--text'},
        {text: 'Ad Group', value: 'adGroupName', class: 'black--text'},
        {text: 'Position', value: 'position', class: 'black--text'},
        {text: 'Keyword Mode', value: 'mode', class: 'black--text'},
        {text: 'Max CPC', value: 'maxCpc', class: 'black--text'},
        {text: 'First CPC', value: 'firstCpc', class: 'black--text'},
        {text: 'Top CPC', value: 'topCpc', class: 'black--text'},
        {text: 'First Page CPC', value: 'firstPageCpc', class: 'black--text'},
        {text: 'Total Calls', value: 'totalCalls', class: 'black--text'},
        {text: 'Total Web Inquiries', value: 'totalWebInq', class: 'black--text'},
        {text: 'Expenses', value: 'totalCost', class: 'black--text'},
        {text: 'Total Orders', value: 'totalOrders', class: 'black--text'},
        {text: 'Total Conversions', value: 'totalConversation', class: 'black--text'},
        {text: 'Total Clicks', value: 'totalClicks', class: 'black--text'},
        {text: 'Total Impressions', value: 'totalImpressions', class: 'black--text'},
        {text: 'Quality Score', value: 'qualityScore', class: 'black--text'},
        {text: 'Ratio', value: 'ratio', class: 'black--text'},
        {text: 'Created Date', value: 'createdAt', class: 'black--text'},
      ],
      customHeader: ['actions', 'status', 'rank_keyword_campaign', 'totalGallons',
        'text', 'matchType', 'adGroupName', 'position', 'mode', 'maxCpc',
        'firstCpc', 'topCpc', 'totalCalls', 'totalCost', 'totalOrders', 'totalConversation',
        'totalClicks', 'totalImpressions', 'firstPageCpc', 'createdAt', 'qualityScore', 'ratio'],
      selectedHeaders: [],
      allAdGroups: [],
      adGroups: [],
      budgetCampaign: 0,
      role: null,
      rights: [],
      adGroupSelect: 0,
      matchTypes: [
        {name: 'Exact match', id: 'EXACT'},
        {name: 'Phrase match', id: 'PHRASE'},
        {name: 'Broad match', id: 'BROAD'},
      ],
      selectedMatch: null,
      loaded: false,
      loadedTotalCPC: false,
      loadedFirstCPC: false,
      loadedTopCPC: false,
      keywordIndexList: [],
      matchTypeIndexList: [],
      kywordsUnicKeys:new Map(),
      columnsData: [],
      dialogRankHistory: false,
      loadedHistory: false,
      dateEndHistory: new Date().toISOString().substr(0, 10),
      dateStartHistory: new Date(new Date().setDate(new Date().getDate() - 89)).toISOString().substr(0, 10),
      dateEndFirstCPC: new Date().toISOString().substr(0, 10),
      dateStartFirstCPC: new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              1)).toISOString().substr(0, 10),
      dateEndTopCPC: new Date().toISOString().substr(0, 10),
      dateStartTopCPC: new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              1)).toISOString().substr(0, 10),
      dateEndTotalCPC: new Date().toISOString().substr(0, 10),
      dateStartTotalCPC: new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              1)).toISOString().substr(0, 10),
      excludePeriodCPC: [],
      defaultPeriodCPC: 3,
      rankSales: [],
      selectedKeyword: null,
      seriesRankHistory: [
        {
          name: 'Rank',
          type: 'line',
          data: []
        },
        {
          name: `Sales`,
          type: 'scatter',
          data: []
        },
        {
          name: `Sales`,
          type: 'scatter',
          data: []
        },
        {
          name: `Notation`,
          type: 'scatter',
          data: []
        }
      ],
      chartOptionsRankHistory: {
        chart: {
          height: 350,
          type: 'line',
          id: 'chartRankHistory',
        },
        offsetX: 0,
        offsetY: 0,
        stroke: {
          curve: 'smooth',
          width: [2, 2]
        },
        fill: {
          type: 'solid',
        },
        colors: ['#6372c3'],
        markers: {
          size: [4, 4],
          colors: ['#6372c3'],
          strokeWidth: 1,
        },
        annotations: {
          xaxis: [
            {
              x: new Date('13 Mar 2021').getTime(),
              borderColor: '#775DD0',
              fillColor: '#c2c2c2',
              label: {
                text: null
              }
            }
          ]
        },
        tooltip: {
          shared: false,
          intersect: true,
          x: {
            show: false
          },
          y: [],
          fixed: {
            enabled: false,
            position: 'topRight',
            offsetX: 0,
            offsetY: 0,
          },
          custom: function (opts) {
            const name =
                opts.ctx.w.config.series[opts.seriesIndex].name

            const color =
                opts.ctx.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                    ].fillColor

            const date =
                opts.ctx.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex].x

            const value = opts.series[opts.seriesIndex][opts.dataPointIndex]

            const data = opts.ctx.w.config.series[opts.seriesIndex].data

            const selectedCampaign = data.reduce((acc, e) => (e.id == self.selectedCampaign) ? [...acc, e] : acc, [])
            const notSelectedCampaign = data.reduce((acc, e) => (e.id !== +self.selectedCampaign) ? [...acc, e] : acc, [])

            const salesSelectedCampaign = self.groupsByDate(selectedCampaign).find(e => e.date === date)?.value.length
            const salesNotSelectedCampaign = self.groupsByDate(notSelectedCampaign).find(e => e.date === date)?.value.length

            const gallonsNotSelectedCampaigns = self.groupsByDate(notSelectedCampaign).find(e => e.date === date)?.value.reduce((acc, e) => acc + e.gallons, 0)
            const gallonsSelectedCampaign = self.groupsByDate(selectedCampaign).find(e => e.date === date)?.value.reduce((acc, e) => acc + e.gallons, 0)

            const countSelectedCampaignSales = self.groupsByDate(selectedCampaign).find(e => e.date === date)
            const selectedCampaignName = countSelectedCampaignSales?.value.map(e => e.description)
            const countNotSelectedCampaignSales = self.groupsByDate(notSelectedCampaign).find(e => e.date === date)
            const notSelectedCampaignsNames = countNotSelectedCampaignSales?.value.map(e => e.description)

            const notation = self.groupsByDate(data).find(e => e.date === date)?.value.map(e => e.comment)

            let content
            if (opts.seriesIndex === 0) {
              content = `<b>${name}</b>${value}`
            }
            if (opts.seriesIndex === 1) {
              content = `<b>${selectedCampaignName}</b><br/><b>Sales:</b> ${salesSelectedCampaign}<br/><b>Gallons: </b>${gallonsSelectedCampaign}`
            }
            if (opts.seriesIndex === 2) {
              content = `<b>All sales: </b> ${salesNotSelectedCampaign} <br/>
                                                                        <b>All gallons: </b>${gallonsNotSelectedCampaigns}<br/> 
                                                                        <b>Campaigns: </b>${notSelectedCampaignsNames}`
            }
            if (opts.seriesIndex === 3) {
              content = `<div class="notation">${notation}</div>`
            }

            return `<div>
                  <span class="px-5" style="background-color:${color}20; display:block"><b>${date.slice(0, 10)}</b></span>   
                    <span class="px-5 my-1" style="display:block">
                      ${content}</span>         
                </div>`
          }
        },
        legend: {
          show: false
        },
        xaxis: {
          type: 'datetime',
          offsetX: 0,
          offsetY: 0,
          axisBorder: {
            show: true,
            color: '#78909C',
            height: 1,
            width: '100%',
            offsetX: 0,
            offsetY: 0
          },
          axisTicks: {
            show: true,
            borderType: 'solid',
            color: '#78909C',
            height: 1,
            offsetX: 0,
            offsetY: 0
          },
          labels: {
            show: true,
            rotate: -45,
            hideOverlappingLabels: true,
            formatter: function (value, timestamp, opts) {
              return opts.dateFormatter(new Date(timestamp), 'MM/dd/yyyy')
            }
          }
        },
        yaxis: {
          type: 'numeric',
          title: 'Rank',
          min: 0,
          forceNiceScale: true,
          labels: {
            formatter: (value) => {
              return value
            }
          },
        },
        grid: {
          show: true,
          strokeDashArray: 1,
          padding: {
            top: 0,
            right: 10,
            bottom: 0,
            left: 10
          },
          xaxis: {
            lines: {
              show: true
            }
          },
          yaxis: {
            lines: {
              show: true
            }
          },
        },

      },
      scrollLeft: 0,
      scrollWidth: 0,
      clientWidth: 0,
      hoverOnTable: false,
      notations: [],
      dialogAddComment: false,
      menuCommentData: false,
      dateComment: null,
      commentText: null,
      commentId: null,
      isExistComment: false,
      loadedSetting: true,
      settingsLoaded: false,
      clientId: 1,
      dialogSimple: false,
      dialogSimpleType: "web" // or call
    }
  },
  watch: {
    optionsDataTable: {
      handler() {
        if (this.selectedCampaign == null) {
          return
        }
        this.fetchCampaign(this.selectedCampaign)
      },
      deep: true,
    },
    filters: {
      handler() {
        if (this.selectedCampaign == null) {
          return
        }
        this.fetchCampaign(this.selectedCampaign)
      },
      deep: true,
    },
    search: function () {
      if (this.selectedCampaign == null) {
        return
      }

      this.checkSearch(this.fetchCampaign)
    },
    maxCpcEntire: function (val) {
      this.fullKeywordForm.maxCpc = val * 1000000
    },
    selectedCampaign: function (val) {
      for (let i = 0; i < this.allCampaigns.length; i++) {
        if (this.allCampaigns[i].campaignId == parseInt(val)) {
          this.budgetCampaign = this.allCampaigns[i].budget / 1000000
        }
      }
      this.fetchCampaign(val)

      this.fetchKeyword4Campaign(val)

    },
    selectedAd: function (val) {
      for (let i = 0; i < this.allCampaigns.length; i++) {
        if (this.allCampaigns[i].id === val) {
          this.adGroupSelect = this.allCampaigns[i].countAd
        }
      }
    },
    value(val) {
      this.selectedHeaders = val
      this.getHeaderForExcel()
    },
    hoverOnTable() {
      this.showScrollingArrows()
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.showScrollingArrows)
  },
  mounted() {
    axios
        .get('/users/me')
        .then(response => {
          this.role = response.data.data.role
          this.rights = response.data.data.rights
        })

    axios
        .get('/campaigns/active')
        .then(response => {
          this.allCampaigns = response.data
          for (let i = 0; i < this.allCampaigns.length; i++) {
            this.allAdGroups.push({name: this.allCampaigns[i].adGroupName, id: this.allCampaigns[i].id})
          }

          this.campaigns = this._.chain(this.allCampaigns)
              .groupBy("campaignId")
              .map((value, key) => ({id: key, name: value[0].campaignName}))
              .value()
        })

    let userName = localStorage.getItem('username')
    let settings = this.settingsName
    let clientId = (localStorage.getItem('ClientId')) ? localStorage.getItem('ClientId') : 1
    this.clientId = clientId
    if (clientId > 2) {
      this.headers.splice(this.headers.findIndex(x=>x.value === 'rank_keyword_campaign'), 1)
      this.headers.splice(this.headers.findIndex(x=>x.value === 'totalGallons'), 1)
      this.headers.splice(this.headers.findIndex(x=>x.value === 'totalOrders'), 1)

      this.value.splice(this.value.findIndex(x=>x.value === 'rank_keyword_campaign'), 1)
      this.value.splice(this.value.findIndex(x=>x.value === 'totalGallons'), 1)
      this.value.splice(this.value.findIndex(x=>x.value === 'totalOrders'), 1)

      this.customHeader.splice(this.customHeader.findIndex(x=>x === 'rank_keyword_campaign'), 1)
      this.customHeader.splice(this.customHeader.findIndex(x=>x === 'totalGallons'), 1)
      this.customHeader.splice(this.customHeader.findIndex(x=>x === 'totalOrders'), 1)
    }
    if (localStorage.getItem(`${userName}.${clientId}.${settings}`)) {

      try {

        let valueCash = JSON.parse(localStorage.getItem(`${userName}.${clientId}.${settings}`))
        this.value = valueCash.filter(e => this.headers.find(item => item.value === e.value))

        const parsed = JSON.stringify(this.value)
        localStorage.setItem(`${userName}.${clientId}.${settings}`, parsed)

        this.customHeader = this.value.map(e => e.value)

        this.getHeaderForExcel()
      } catch (e) {
        console.log("")
      }
    }

    this.getNotations()
    this.showScrollingArrows()
  },
  created() {
    this.selectedHeaders = this.value
    this.getHeaderForExcel()

    window.addEventListener("resize", this.showScrollingArrows)
  },
  computed: {
    managementRight() {
      return (this.role === "Admin")
          ? true
          : this.rights.includes('cruiseCampaignManagement')
    },
    rankRight() {
      return (this.rights == {}) ? false : this.rights.includes('rank')
    },
    selectedCampaignName() {
      if (!this.campaigns || !this.selectedCampaign) {
        return ''
      }
      return this.campaigns.find(e => e.id === this.selectedCampaign).name
    },
    dataFilteredForExcel() {
      console.log('dataFilteredForExcel')
      if (!this.data) return []
      let data = JSON.parse(JSON.stringify(this.data))
      console.log('KEYWORD', data)

      data.map(e => {
        e.movement = (e.movement) ? 'Up' : ''
        e.dailySpent = (e.dailySpent > 0) ? parseFloat(e.dailySpent / 1000000).toFixed(2) : 0
        e.avgCpc = (e.avgCpc > 0) ? parseFloat(e.avgCpc / 1000000).toFixed(2) : 0
        e.maxCpc = (e.maxCpc > 0) ? parseFloat(e.maxCpc / 1000000).toFixed(2) : 0
        e.totalCost = (e.totalCost > 0) ? parseFloat(e.totalCost / 1000000).toFixed(2) : 0
        e.firstCpc = (e.firstCpc > 0) ? parseFloat(e.firstCpc / 1000000).toFixed(2) : 0
        e.topCpc = (e.topCpc > 0) ? parseFloat(e.topCpc / 1000000).toFixed(2) : 0
      });
      return data
    },
    createSheetName() {
      let name = this.selectedCampaignName
      if (name.length > 30) name = name.substr(0, 30)
      name = name.replace(/(\\|\/)/g, '-')
      return name
    },
    campaignStatus() {
      let status = 'Normal'
      if (this.settings.cruiseControl) {
        status = 'Automated Cruise'
      }
      if (this.settings.isSemiAutomated) {
        status = 'Semi-automated Cruise'
      }
      return status
    },
    hasIssueWithMode() {
      if (this.settings.hasPositionIssue) {
        return 'red'
      }

      return 'primary'
    }
  },
  methods: {
    checkSearch: _.debounce(function (fnc) {
      fnc()
    }, 1000),
    openSaleReport(orderIds){
      let dateStart = new Date().toISOString().substr(0, 10);

      let dateEnd = moment().subtract(90, "days").format("YYYY-MM-DD");

      let orders = JSON.stringify({
        report: 'geoSalesReport',
        order_ids: orderIds.map(e=>parseInt(e)),
        dateStart: dateEnd,
        dateEnd: dateStart,
        defaultPeriod: this.defaultPeriod
      })
      localStorage.setItem('orders', orders)

      let routeData = this.$router.resolve({name: 'sales'})
      window.open(routeData.href, '_blank')
    },
    clearSelected() {
      this.selected = []
      this.changeActions()
    },
    getNotations() {
      axios
          .get('rank-notation')
          .then(response => {
            this.notations = response.data
            this.notations.map(e => e.data = e.data.substr(0, 10))

            this.seriesRankHistory[3].data = this.notations.map(el => {
              return {
                id: el.id,
                x: el.data + ' GMT',
                y: 0,
                fillColor: '#d87691',
                comment: el.comment
              }
            })
          })
    },
    scrollingRight() {
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft + 50

      const btnRight = document.querySelector('.btn-right-arrow')
      const btnLeft = document.querySelector('.btn-left-arrow')
      btnRight.style.visibility = (this.hoverOnTable && (el.scrollLeft + el.clientWidth != el.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    scrollingLeft() {
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft - 50

      const btnLeft = document.querySelector('.btn-left-arrow')
      const btnRight = document.querySelector('.btn-right-arrow')
      btnLeft.style.visibility = (this.hoverOnTable && (el.scrollLeft != 0)) ? 'visible' : 'hidden'
      btnRight.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    showScrollingArrows() {
      const el = document.querySelector('.v-data-table__wrapper')
      this.scrollLeft = el.scrollLeft
      this.scrollWidth = el.scrollWidth
      this.clientWidth = el.clientWidth

      const btnRight = document.querySelector('.btn-right-arrow')
      const btnLeft = document.querySelector('.btn-left-arrow')
      btnRight.style.visibility = (this.hoverOnTable && (this.scrollLeft + this.clientWidth !== this.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = (this.hoverOnTable && (this.scrollLeft != 0)) ? 'visible' : 'hidden'
    },
    groupsByDate(data) {
      return this._.chain(data)
          .groupBy("x")
          .map((value, key) => ({date: key, value: value}))
          .value()
    },
    rowClick: function (item, row) {
      let selectState = (row.isSelected) ? false : true
      row.select(selectState)
    },
    getDatesHistory(dates) {
      this.dateStartHistory = dates.dateStart
      this.dateEndHistory = dates.dateEnd
      this.getRankHistory(this.selectedKeyword)
    },
    getDatesFirstCPC(dates) {
      this.dateStartFirstCPC = dates.dateStart
      this.dateEndFirstCPC = dates.dateEnd
      this.getFirstCPC(this.selectedKeyword)
    },
    getDatesTopCPC(dates) {
      this.dateStartTopCPC = dates.dateStart
      this.dateEndTopCPC = dates.dateEnd
      this.getTopCPC(this.selectedKeyword)
    },
    getDatesTotalCPC(dates) {
      this.dateStartTotalCPC = dates.dateStart
      this.dateEndTotalCPC = dates.dateEnd
      this.getAllCPC(this.selectedKeyword)
    },
    closeHistory() {
      this.dialogRankHistory = false
      this.loadedHistory = false
    },
    showSimpleAlert(item, type){
      this.dialogSimple = true
      this.dialogSimpleType = type
      this.selectedKeyword = item
    },
    getRankHistory(item) {
      this.selectedKeyword = item
      this.getNotations()
      this.dialogRankHistory = true
      this.loadedHistory = true

      axios
              .get('/rank-history/' + this.selectedKeyword.id + '/' + this.selectedCampaign + '/' + this.dateStartHistory + '/' + this.dateEndHistory)
          .then(response => {
            response.data.sales.sort((a, b) => new Date(a.saleDate) - new Date(b.saleDate))

            this.seriesRankHistory[0].data = response.data.data.map(el => {
              return {x: el.createdDate.split(' ')[0] + ' GMT', y: el.rank.toFixed(2), fillColor: '#6372c3'}
            })

            this.seriesRankHistory[1].data = response.data.sales
                .filter(e => e.campaignId == this.selectedCampaign)
                .map(el => {
                  return {
                    description: el.campaignName,
                    id: el.campaignId,
                    x: el.saleDate.split(' ')[0] + ' GMT',
                    y: 3,
                    fillColor: '#1ca539',
                    gallons: el.gallons
                  }
                })

            this.seriesRankHistory[2].data = response.data.sales
                .filter(e => e.campaignId != this.selectedCampaign)
                .map(el => {
                  return {
                    description: el.campaignName,
                    id: el.campaignId,
                    x: el.saleDate.split(' ')[0] + ' GMT',
                    y: 1,
                    fillColor: '#f79e20',
                    gallons: el.gallons
                  }
                })

            this.chartOptionsRankHistory.annotations.xaxis =
                [...this.seriesRankHistory[1].data,
                  ...this.seriesRankHistory[2].data,
                  ...this.seriesRankHistory[3].data]
                    .map(e => {
                      return {x: new Date(e.x).getTime(), borderColor: e.fillColor, label: {text: ''}}
                    })

            let maxRankHistory = Math.ceil(Math.max(...this.seriesRankHistory[0].data.map(e => +e.y)))
            let min = _.minBy(response.data.data, 'rank');
            if (min) {
              min = min.rank
            }

            this.chartOptionsRankHistory.yaxis.max = (maxRankHistory < 11) ? maxRankHistory : Math.ceil(maxRankHistory / 10) * 10
            this.chartOptionsRankHistory.yaxis.tickAmount = (maxRankHistory < 6) ? maxRankHistory : 5
            this.chartOptionsRankHistory.yaxis.min = min < 0 ? min : 0
            this.loadedHistory = false
          })

    },
    validate() {
      this.$refs.form.validate()
    },
    getCustomData({customHeader, value, selectedHeaders}) {
      this.customHeader = customHeader
      this.value = value
      this.selectedHeaders = selectedHeaders

      this.getHeaderForExcel()
    },
    getHeaderForExcel() {
      this.columnsData = this.selectedHeaders.map(e => {
        const obj = {}
        if (e.value !== "actions") {
          obj.label = e.text
          obj.field = e.value
        }
        if (e.value === "totalCost") {
          obj.label = `${e.text},$`
          obj.field = e.value
        }
        return obj
      }).filter(value => Object.keys(value).length !== 0);

      console.log('this.columnsData', this.columnsData)
    },

    fetchKeyword4Campaign(id_campaign){
      if (!id_campaign) return;
      axios.get(`/keywordsapi/keywords4campaign/${id_campaign}`)
          .then(response=>{
            let kwdata = response.data.data
            for (let i = 0; i < kwdata.length; i++) {
              const dataitem = kwdata[i]
              const ukey = this.makeUnicKeyForKeywored(dataitem.text,'','');

              this.kywordsUnicKeys.set( ukey , true)
            }

          })
    },

    fetchCampaign(val) {
      if (val === null || val === undefined) {
        val = this.selectedCampaign
      }
      if (val === null || val === undefined) {
        console.log("No company ID")
        return
      }

      this.selected = []
      this.loaded = true
      const {sortBy, sortDesc, page, itemsPerPage} = this.optionsDataTable
      axios
          .get(`/keywords/${val}?filters=${JSON.stringify(this.filters)}&sortBy=${sortBy}&sortDesc=${sortDesc}&page=${page}&itemsPerPage=${itemsPerPage}&search=${this.search}`)
          .then(response => {
            this.data = response.data.data
            if(response.data.timecashing){
              console.log(response.data.timecashing)
              let date = new Date(response.data.timecashing);
              console.log(date)
              self.DateUpdateCache4Data = date;
            }
            console.log('fetchCampaign this.data', this.data)
            this.totalRows = response.data.totalRows
            this.adGroupNameFilter = response.data.adGroupNameFilter

            for (let i = 0; i < this.data.length; i++) {
              this.data[i].adGroupName = this.getAdGroupName(this.data[i].adGroupId)
              this.data[i].uid = this.data[i].adGroupId + this.data[i].id
            }

            let totalSpentDay = this._.sumBy(this.data, 'dailySpent')
            //totalSpentDay = Math.floor(totalSpentDay * 100) / 100
            if (totalSpentDay > 0) {
              totalSpentDay = totalSpentDay / 1000000
            }

            this.adGroups = []
            for (let i = 0; i < this.allCampaigns.length; i++) {
              if (this.allCampaigns[i].campaignId.toString() === val.toString() && this.allCampaigns[i].status.toString() === "ENABLED") {
                this.adGroups.push({name: this.allCampaigns[i].adGroupName, id: this.allCampaigns[i].id})
              }
            }

            this.statisticForCurrentDay.totalCalls = this._.sumBy(this.data, 'dailyCalls')
            this.statisticForCurrentDay.totalClicks = this._.sumBy(this.data, 'dailyClicks')
            this.statisticForCurrentDay.totalSpentDay = totalSpentDay

            this.keywordIndexList = []
            this.matchTypeIndexList = []

            for (let i = 0; i < this.data.length; i++) {
              this.keywordIndexList.push(this.data[i].text)
              this.matchTypeIndexList.push(this.data[i].matchType)
            }

            this.loaded = false
          });
    },
    getAdGroupName(id) {
      for (let i = 0; i < this.allCampaigns.length; i++) {
        if (this.allCampaigns[i].id == id) {
          return this.allCampaigns[i].adGroupName
        }
      }
      return ""
    },
    getHistory(item) {
      axios
          .get('/movements/' + item.id + '/' + item.adGroupId)
          .then(response => {
            this.historyChanged = response.data
            this.dialogHistory = true
          });
    },
    getDates(dates) {
      this.dateStart = dates.dateStart
      this.dateEnd = dates.dateEnd
      this.applyFilters()
    },
    getAllCPC(item) {
      this.selectedKeyword = item
      this.itemCPC.id = item.id
      this.itemCPC.adGroupId = item.adGroupId

      this.dialogTotalCPC = true
      this.loadedTotalCPC = true

      axios
          .get('/keyword-history/' + item.id + '/' + item.adGroupId + '/' + this.dateStartTotalCPC + '/' + this.dateEndTotalCPC + '/all')
          .then(response => {

            let series1 = {
              name: 'First CPC',
              data: response.data.data.map(el => el.firstCpc.toFixed(2)).map(Number),
              color: '#F79E20',
              type: 'line'
            }
            let series2 = {
              name: 'Top CPC',
              data: response.data.data.map(el => el.topCpc.toFixed(2)).map(Number),
              color: '#586ACE',
              type: 'line',
              visible: false
            }
            let series3 = {
              name: 'First Page CPC',
              data: response.data.data.map(el => el.firstPageCpc.toFixed(2)).map(Number),
              color: '#43A357',
              type: 'line',
              visible: false
            }
            let series4 = {
              name: 'Max CPC',
              data: response.data.data.map(el => el.maxCpc.toFixed(2)).map(Number),
              color: '#D87691',
              type: 'line'
            }
            let series5 = {
              name: 'Abs. top of page',
              data: response.data.data.map(el => el.absTop.toFixed(2)).map(Number),
              color: '#398BD8',
              type: 'line',
              dashStyle: 'shortdot',
              yAxis: 1,
              visible: false
            }
            let series6 = {
              name: 'Impression Share ',
              data: response.data.data.map(el => el.imprShare.toFixed(2)).map(Number),
              color: '#6639d8',
              type: 'line',
              dashStyle: 'shortdot',
              yAxis: 1,
              visible: false
            }
            let series7 = {
              name: 'Top of page ',
              data: response.data.data.map(el => el.topPage.toFixed(2)).map(Number),
              color: '#8639d8',
              type: 'line',
              dashStyle: 'shortdot',
              yAxis: 1,
              visible: false
            }
            let series8 = {
              name: 'Quality score',
              data: response.data.data.map(el => el.qScore.toFixed(2)).map(Number),
              color: '#398BD8',
              type: 'line',
              dashStyle: 'shortdot',
              visible: false
            }
            let series9 = {
              name: 'Conversions',
              data: response.data.data.map(el => el.conversions.toFixed(2)).map(Number),
              color: '#694BD8',
              type: 'line',
              dashStyle: 'dot',
              yAxis: 2,
              visible: false
            }
            let series10 = {
              name: 'Clicks',
              data: response.data.data.map(el => el.clicks.toFixed(2)).map(Number),
              color: '#61d836',
              type: 'line',
              dashStyle: 'dot',
              yAxis: 2,
            }
            let series11 = {
              name: 'Impressions',
              data: response.data.data.map(el => el.impressions.toFixed(2)).map(Number),
              color: '#9039d8',
              type: 'line',
              dashStyle: 'dot',
              yAxis: 2,
            }
            let series12 = {
              name: 'Rank',
              data: response.data.data.map(el => el.rank.toFixed(2)).map(Number),
              color: '#9039d8',
              type: 'line',
              yAxis: 3,
            }
            this.chartOptionsAll.series = [series1, series2, series3, series4, series5, series6, series7, series8, series9, series10, series11, series12]
            this.chartOptionsAll.xAxis.categories = response.data.data.map(el => el.createdDate)
            this.chartOptionsAll.xAxis.plotBands = []

            let filledIndex = [];
            for (let s of response.data.sales) {
              let date = s.saleDate.split(" ")[0];
              let start = null
              let end = null
              let color = "rgba(247,158,32)"

              if (s.campaignId == this.selectedCampaign) {
                color = "rgba(28,165,57)"
              }
              let index = 0

              for (let dt in this.chartOptionsAll.xAxis.categories){
                if (start !== null && end !== null) {
                  continue
                }

                let d = this.chartOptionsAll.xAxis.categories[dt].split(" ")[0]

                if (d === date && start == null) {
                  if (filledIndex.indexOf(index) > -1){
                    index++
                    continue;
                  }

                  filledIndex.push(index)
                  start = index
                  end = index
                }
                index++
              }
              if (start === null && end === null) {
                continue
              }

              this.chartOptionsAll.xAxis.plotBands.push({
                from: start,
                to: end,
                color: color
              })
            }

            this.loadedTotalCPC = false
          });
    },
    getTopCPC(item) {
      this.selectedKeyword = item
      this.itemCPC.id = item.id
      this.itemCPC.adGroupId = item.adGroupId

      this.dialogTopCPC = true
      this.loadedTopCPC = true

      axios
          .get('/keyword-history/' + item.id + '/' + item.adGroupId + '/' + this.dateStartTopCPC + '/' + this.dateEndTopCPC + '/top')
          .then(response => {

            this.topCPC = {
              'labels': response.data.data.map(el => el.createdDate),
              'datasets': [
                {
                  label: 'Top CPC',
                  borderColor: 'rgba(99, 114, 195, 1)',
                  backgroundColor: 'rgba(242, 243, 252, 0.4)',
                  borderWidth: 1,
                  data: response.data.data.map(el => el.cpc.toFixed(2))
                }
              ]
            }
            this.loadedTopCPC = false
          });

    },
    getFirstCPC(item) {
      this.selectedKeyword = item
      this.itemCPC.id = item.id
      this.itemCPC.adGroupId = item.adGroupId

      this.dialogFirstCPC = true
      this.loadedFirstCPC = true

      axios
          .get('/keyword-history/' + item.id + '/' + item.adGroupId + '/' + this.dateStartFirstCPC + '/' + this.dateEndFirstCPC + '/first')
          .then(response => {

            this.firstCPC = {
              'labels': response.data.data.map(el => el.createdDate),
              'datasets': [
                {
                  label: 'First CPC',
                  borderColor: 'rgba(99, 114, 195, 1)',
                  backgroundColor: 'rgba(242, 243, 252, 0.4)',
                  borderWidth: 1,
                  data: response.data.data.map(el => el.cpc.toFixed(2))
                }
              ]
            }
            this.loadedFirstCPC = false
          })
    },
    getFirstPageCPC(item) {
      this.selectedKeyword = item
      this.itemCPC.id = item.id
      this.itemCPC.adGroupId = item.adGroupId

      this.dialogFirstCPC = true
      this.loadedFirstCPC = true

      axios
          .get('/keyword-history/' + item.id + '/' + item.adGroupId + '/' + this.dateStartFirstCPC + '/' + this.dateEndFirstCPC + '/first_page')
          .then(response => {

            this.firstCPC = {
              'labels': response.data.data.map(el => el.createdDate),
              'datasets': [
                {
                  label: 'First Page CPC',
                  borderColor: 'rgb(174,99,195)',
                  backgroundColor: 'rgba(242, 243, 252, 0.4)',
                  borderWidth: 1,
                  data: response.data.data.map(el => el.cpc.toFixed(2))
                }
              ]
            }
            this.loadedFirstCPC = false
          })
    },
    applyFilters() {

      axios
          .get('/keyword-history/' + this.itemCPC.id + '/' + this.itemCPC.adGroupId + '/' + this.dateStart + '/' + this.dateEnd + '/top')
          .then(response => {

            this.topCPC = {
              'labels': response.data.data.map(el => el.createdDate),
              'datasets': [
                {
                  label: 'Top CPC',
                  borderColor: '#336EB1',
                  data: response.data.data.map(el => el.cpc)
                }
              ]
            }
          });
      axios
          .get('/keyword-history/' + this.itemCPC.id + '/' + this.itemCPC.adGroupId + '/' + this.dateStart + '/' + this.dateEnd + '/first')
          .then(response => {

            this.firstCPC = {
              'labels': response.data.data.map(el => el.createdDate),
              'datasets': [
                {
                  label: 'First CPC',
                  borderColor: '#336EB1',
                  data: response.data.data.map(el => el.cpc)
                }
              ]
            }
          });
    },
    closeCPC() {
      this.dialogTotalCPC = false
      this.dialogTopCPC = false
      this.dialogFirstCPC = false
      this.dateEnd = new Date().toISOString().substr(0, 10)
      this.dateStart = new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() - 10
      ).toISOString().substr(0, 10)
    },
    getColor(value) {
      if (value == true) return 'green'
      else return ''
    },
    cleanSelectedAction() {
      this.selectedInxAction = null
      this.selectedInxModeAction = null
      this.selectedInxCPCAction = null
    },
    selectAction(i) {
      this.selectedAction = this.bulkActions[i].value
      this.selectedActionConfirmText = this.bulkActions[i].confirmation
      this.dialogConfirmBulkAction = true
    },
    selectModeAction(i) {
      this.selectedAction = this.bulkModeActions[i].value
      this.selectedActionConfirmText = this.bulkModeActions[i].confirmation
      this.dialogConfirmBulkAction = true
    },
    selectChangeCPC() {
      this.selectedAction = this.bulkCPCActions[0].value
      this.applyAction()
    },
    cancelChangeCPC() {
      this.maxCpcEntire = null
      this.menuBulkEdit = false
    },
    applyAction() {
      switch (this.selectedAction) {
        case 'pause':
          this.changeStatus("PAUSED")
          break;
        case 'resume':
          this.changeStatus("ENABLED")
          break;
        case 'SportFirstMode':
          this.makeSportFirst()
          break;
        case 'SportTopMode':
          this.makeSportTop()
          break;
        case 'SportFirstPageMode':
          this.makeSportFirstPage()
          break;
        case 'normal':
          this.makeNormal()
          break;
        case 'changeMaxCpc':
          this.changeMaxCpc()
          break;
        case 'overrideSettings':
          this.overrideSettings()
          break;
        case 'resetSettings':
          this.resetSettings()
          break;
      }

      this.selectedAction = ''
      this.dialogConfirmBulkAction = false
      this.menuBulkEdit = false
      this.ratio = 1
    },
    cancelAction() {
      this.selectedAction = ''
      this.selectedActionConfirmText = ''
      this.dialogConfirmBulkAction = false
    },
    changeMaxCpc() {
      let payload = []

      for (let item of this.selected) {
        for (let dat of this.data) {
          if (item.uid == dat.uid) {
            dat.maxCpc = this.maxCpcEntire * 1000000

            if (dat.maxCpc >= dat.firstCpc) {
              dat.position = 'First'
            }
            if (dat.maxCpc >= dat.topCpc && dat.firstCpc > dat.maxCpc) {
              dat.position = 'Top'
            }
            if (dat.maxCpc < dat.topCpc) {
              dat.position = 'NA'
            }

            payload.push({
              adGroupId: dat.adGroupId,
              id: dat.id,
              mode: dat.mode,
              cpc: dat.maxCpc
            })
          }
        }
      }

      if (payload.length > 0) {
        axios.post('/bulk/cpc', {payload: payload})
      }

      this.maxCpcEntire = null
    },
    editKeywordMode(mode) {
      switch (mode) {
        case 'Normal':
          this.selectedActionAtEdit = 'normal'
          this.maxCpcEntire = 1
          break;
        case 'Top':
          this.selectedActionAtEdit = 'SportTopMode'
          if (this.settings.maxSportTop && this.fullKeywordForm.topCpc <= 100000) {
            this.maxCpcEntire = this.settings.maxSportTop / 2
          } else {
            this.maxCpcEntire = this.settings.maxSportTop
          }
          break;
        case 'First':
          this.selectedActionAtEdit = 'SportFirstMode'
          if (this.settings.maxSportFirst > 0 && this.fullKeywordForm.firstCpc <= 100000) {
            this.maxCpcEntire = this.settings.maxSportFirst / 2
          } else {
            this.maxCpcEntire = this.settings.maxSportFirst
          }
          break;
        case 'FirstPage':
          this.selectedActionAtEdit = 'SportFirstPageMode'
          if (this.settings.maxSportFirstPage > 0 && this.fullKeywordForm.firstPageCpc <= 100000) {
            this.maxCpcEntire = this.settings.maxSportFirstPage / 2
          } else {
            this.maxCpcEntire = this.settings.maxSportFirstPage
          }
          break;
      }
    },
    editKeywordStatus(status) {
      console.log(status)
      switch (status) {
        case 'Active':
          this.selectedStatusAtEdit = 'resume'
          break;
        case 'Stopped':
          this.selectedStatusAtEdit = 'pause'
          break;
      }
    },
    applyActionAtEdit() {
      let timeout = 10
      let timeoutMax = 3000
      switch (this.selectedStatusAtEdit) {
        case 'pause':
          this.changeStatus("PAUSED")
          this.selectedStatusAtEdit = ''
          timeout = timeoutMax
          break;
        case 'resume':
          this.changeStatus("ENABLED")
          this.selectedStatusAtEdit = ''
          timeout = timeoutMax
          break;
      }

      switch (this.selectedActionAtEdit) {
        case 'SportFirstMode':
          this.makeSportFirst()
          this.selectedActionAtEdit = ''
          timeout = timeoutMax
          break;
        case 'SportTopMode':
          this.makeSportTop()
          this.selectedActionAtEdit = ''
          timeout = timeoutMax
          break;
        case 'SportFirstPageMode':
          this.makeSportFirstPage()
          this.selectedActionAtEdit = ''
          timeout = timeoutMax
          break;
        case 'normal':
          this.makeNormal()
          this.selectedActionAtEdit = ''
          timeout = timeoutMax
          break;
      }

      return timeout
    },
    unCheckAll() {
      this.selected = this.selectedTmp
      this.selectedTmp = []
    },
    makeSportFirst() {
      let payload = []
      for (let item of this.selected) {
        for (let dat of this.data) {

          if (item.uid == dat.uid) {
            dat.mode = 'First'
            dat.position = 'First'
            if (dat.firstCpc > 0.1) {
              dat.maxCpc = Math.round(Math.ceil10((parseInt(dat.firstCpc) / 1000000) * this.settings.sportFirst, -1) * 1000000)
            }

            if (dat.maxCpc > (this.settings.maxSportFirst * 1000000)) {
              dat.maxCpc = Math.round(this.settings.maxSportFirst * 1000000)
            }

            if (dat.firstCpc <= 0.1 && this.settings.maxSportFirst > 0) {
              dat.maxCpc = Math.round(Math.ceil10((this.settings.maxSportFirst * 1000000) / 2, -1))
            }

            dat.position = 'NA'

            if (dat.maxCpc >= dat.firstPageCpc) {
              dat.position = 'First Page'
            }
            if (dat.maxCpc >= dat.topCpc) {
              dat.position = 'Top'
            }
            if (dat.maxCpc >= dat.firstCpc) {
              dat.position = 'First'
            }

            payload.push({
              adGroupId: dat.adGroupId,
              id: dat.id,
              mode: dat.mode,
              cpc: dat.maxCpc
            })

          }
        }
      }

      if (payload.length > 0) {
        axios.post('/bulk/cpc', {payload: payload})
      }

    },
    makeSportTop() {
      let payload = []

      for (let item of this.selected) {
        for (let dat of this.data) {
          if (item.uid == dat.uid) {
            dat.mode = 'Top'
            dat.position = 'Top'

            if (dat.topCpc > 0.1) {
              dat.maxCpc = Math.round(Math.ceil10((parseInt(dat.topCpc) / 1000000) * this.settings.sportTop, -1) * 1000000)
            }

            if (dat.maxCpc > (this.settings.maxSportTop * 1000000)) {
              dat.maxCpc = Math.round(this.settings.maxSportTop * 1000000)
            }

            if (dat.topCpc <= 0.1 && this.settings.maxSportTop > 0) {
              dat.maxCpc = Math.round(Math.ceil10((this.settings.maxSportTop * 1000000) / 2, -1))
            }

            dat.position = 'NA'

            if (dat.maxCpc >= dat.firstPageCpc) {
              dat.position = 'First Page'
            }
            if (dat.maxCpc >= dat.topCpc) {
              dat.position = 'Top'
            }
            if (dat.maxCpc >= dat.firstCpc) {
              dat.position = 'First'
            }

            payload.push({
              adGroupId: dat.adGroupId,
              id: dat.id,
              mode: dat.mode,
              cpc: dat.maxCpc
            })
          }
        }
      }

      if (payload.length > 0) {
        axios.post('/bulk/cpc', {payload: payload})
      }
    },
    overrideSettings() {
      let payload = []

      for (let item of this.selected) {
        for (let dat of this.data) {
          if (item.uid == dat.uid) {
            payload.push({
              adGroupId: dat.adGroupId,
              id: dat.id,
              mode: "overrideSettings",
              ratio: this.ratio
            })
          }
        }
      }

      if (payload.length > 0) {
        axios.post('/bulk/cpc', {payload: payload})
      }

      setTimeout(() => {
        axios.post('/keywords/' + this.selectedCampaign, this.fullKeywordForm).then(() => {
          this.fetchCampaign(this.selectedCampaign)
        })

        this.data.push({})
        this.clearForm()
        this.dialogKeyword = false
        this.maxCpcEntire = 0
        this.selectedActionAtEdit = ''
        this.selectedStatusAtEdit = ''
        this.ratio = 1;
        this.unCheckAll()
      }, 500)
    },
    resetSettings() {
      let payload = []

      for (let item of this.selected) {
        for (let dat of this.data) {
          if (item.uid == dat.uid) {
            payload.push({
              adGroupId: dat.adGroupId,
              id: dat.id,
              mode: "overrideSettings",
              ratio: -1
            })
          }
        }
      }

      if (payload.length > 0) {
        axios.post('/bulk/cpc', {payload: payload})
      }

      setTimeout(() => {
        axios.post('/keywords/' + this.selectedCampaign, this.fullKeywordForm).then(() => {
          this.fetchCampaign(this.selectedCampaign)
        })

        this.data.push({})
        this.clearForm()
        this.dialogKeyword = false
        this.maxCpcEntire = 0
        this.selectedActionAtEdit = ''
        this.selectedStatusAtEdit = ''
        this.ratio = 1;
        this.unCheckAll()
      }, 500)
    },
    makeSportFirstPage() {
      let payload = []
      for (let item of this.selected) {
        for (let dat of this.data) {

          if (item.uid == dat.uid) {
            dat.mode = 'First Page'
            dat.position = 'First Page'
            if (dat.firstPageCpc > 0.1) {
              dat.maxCpc = Math.round(Math.ceil10((parseInt(dat.firstPageCpc) / 1000000) * this.settings.sportFirstPage, -1) * 1000000)
            }

            if (dat.maxCpc > (this.settings.maxSportFirstPage * 1000000)) {
              dat.maxCpc = Math.round(this.settings.maxSportFirstPage * 1000000)
            }

            if (dat.firstPageCpc <= 0.1 && this.settings.maxSportFirstPage > 0) {
              dat.maxCpc = Math.round(Math.ceil10((this.settings.maxSportFirstPage * 1000000) / 2, -1))
            }

            dat.position = 'NA'

            if (dat.maxCpc >= dat.firstPageCpc) {
              dat.position = 'First Page'
            }
            if (dat.maxCpc >= dat.topCpc) {
              dat.position = 'Top'
            }
            if (dat.maxCpc >= dat.firstCpc) {
              dat.position = 'First'
            }

            payload.push({
              adGroupId: dat.adGroupId,
              id: dat.id,
              mode: dat.mode,
              cpc: dat.maxCpc
            })

          }
        }
      }

      if (payload.length > 0) {
        axios.post('/bulk/cpc', {payload: payload})
      }

    },
    makeNormal() {
      let payload = []

      for (let item of this.selected) {
        for (let dat of this.data) {
          if (item.uid == dat.uid) {
            dat.mode = 'Normal'
            dat.position = 'NA'
            dat.maxCpc = 1000000

            payload.push({
              adGroupId: dat.adGroupId,
              id: dat.id,
              mode: dat.mode,
              cpc: 1000000 // $1 FLM-171
            })
          }
        }
      }

      if (payload.length > 0) {
        axios.post('/bulk/cpc', {payload: payload})
      }
    },
    changeStatus(status) {
      let payload = []
      let clonedSelected = JSON.parse(JSON.stringify(this.selected))
      for (let c of clonedSelected) {
        for (let dat of this.data) {
          if (c.id == dat.id && c.adGroupId == dat.adGroupId) {
            payload.push({
              "ad_group_id": dat.adGroupId,
              "keyword_id": dat.id,
              "mode": status
            })

            if (status === "ENABLED") {
              dat.status = 'Active'
            } else {
              dat.status = 'Stopped'
            }
          }
        }
      }

      axios({
        url: '/status',
        method: 'put',
        data: payload
      })
    },
    cleanFilters() {
      this.search = ''

      this.filters.status = []
      this.filters.adGroupName = []
      this.filters.position = []
      this.filters.mode = []
      this.filters.labels = []
    },
    /*eslint-enable no-unused-vars*/
    edit(item) {

      this.selectedTmp = this.selected
      this.selected = [item]

      this.dialogKeyword = true

      this.fullKeywordForm = Object.assign({}, item)
      this.ratio = this.fullKeywordForm.ratio;
      if (this.fullKeywordForm.maxCpc > 0) {
        this.maxCpcEntire = Math.ceil10(this.fullKeywordForm.maxCpc / 1000000, -2)
      }
    },
    clearForm() {
      this.fullKeywordForm = {
        text: '',
        maxCpc: null,
        dailyBudget: null,
        keywords: null
      }
      this.maxCpcEntire = 0
    },
    saveKeyword() {
      if (!this.fullKeywordForm.text) {
        return
      }

      let timeout = this.applyActionAtEdit()

      if (this.fullKeywordForm.adGroupId == null) {
        this.fullKeywordForm.adGroupId = this.selectedAd
      }
      this.fullKeywordForm.campaignId = this.selectedCampaign
      this.fullKeywordForm.ratio = this.ratio

      setTimeout(() => {
        axios.post('/keywords/' + this.selectedCampaign, this.fullKeywordForm).then(() => {
          this.fetchCampaign(this.selectedCampaign)
        })

        this.data.push({})
        this.clearForm()
        this.dialogKeyword = false
        this.maxCpcEntire = 0
        this.selectedActionAtEdit = ''
        this.selectedStatusAtEdit = ''
        this.ratio = 1;
        this.unCheckAll()
      }, timeout)
    },
    cancelKeyword() {
      this.unCheckAll()
      this.selectedActionAtEdit = ''
      this.selectedStatusAtEdit = ''
      this.clearForm()
      this.dialogKeyword = false
    },
    saveKeywords() {
      if (!this.selectedAd || !this.fullKeywordForm.keywords) {
        return
      }

      if (this.fullKeywordForm.adGroupId == null) {
        this.fullKeywordForm.adGroupId = this.selectedAd
      }
      this.fullKeywordForm.campaignId = this.selectedCampaign
      this.fullKeywordForm.matchType = this.selectedMatch
      this.fullKeywordForm.ratio = this.ratio

      axios.post('/bulk/keywords/' + this.selectedCampaign, this.fullKeywordForm).then(() => {
      })
      this.data.push({})
      this.clearForm()
      this.dialogKeywords = false
    },
    cancelKeywords() {
      this.clearForm()
      this.dialogKeywords = false
    },
    getSettings() {
      this.loadedSetting = true
      axios
          .get('/settings-campaign/' + this.selectedCampaign)
          .then(response => {
            this.settings = response.data
            console.log('this.settings', this.settings)
            this.loadedSetting = false
            this.changeActions()
          });
    },
    saveSettings() {
      this.settingsLoaded = true
      axios
          .post('/settings-campaign/' + this.selectedCampaign, this.settings)
          .then(() => {
            this.settingsLoaded = false
            this.dialogSettings = false
            this.changeActions()
          })
    },
    cancelSettings() {
      this.getSettings()
      this.dialogSettings = false
    },
    makeUnicKeyForKeywored(kw_text, match_type, adname){
       let res = String(kw_text) +'|'+ String(match_type)+'|'+ String( adname )
      return res.toUpperCase();
    },
    changeActions() {
      for (let b of this.bulkModeActions) {
        b.disabled = false
        if (['SportFirstMode', 'SportTopMode', 'normal', 'changeMaxCpc', 'SportFirstPageMode'].indexOf(b.value) != -1) {
          b.disabled = this.settings.cruiseControl
        }
        if ((this.filters.mode.includes("Normal") && ['overrideSettings', 'resetSettings'].indexOf(b.value) != -1) || this.filters.mode.length === 0) {
          b.disabled = true
        }
      }

      for (let b of this.bulkCPCActions) {
        b.disabled = false
        if (['changeMaxCpc'].indexOf(b.value) != -1) {
          b.disabled = true
        }
        if (['changeMaxCpc'].indexOf(b.value) != -1 && this.filters.mode.includes("Normal") && this.filters.mode.length === 1) {
          b.disabled = false
        }
      }
    }
  }
}
</script>

<style>
  .v-input--selection-controls__input {
    height: 13px !important;
  }
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
  .v-data-table > .v-data-table__wrapper > table > thead > tr > th,
  .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
    text-align: center !important;
  }
  .v-card .v-sheet .theme--light {
    box-sizing: border-box !important;
  }
  .v-data-table-header th {
    white-space: nowrap;
  }
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 0.75rem !important;
    text-align: center !important;
  }
  .v-application--is-ltr .v-list-item__action {
    margin-right: 10px !important;
  }
  .v-application--is-ltr .v-input--selection-controls__input {
    margin-right: 0px;
  }
  .max-cpc {
    line-height: 2.75rem !important;
  }
  .theme--light.v-data-table tbody tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03);
  }
  .theme--dark.v-data-table tbody tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .5);
  }
  .theme--light.v-data-table tbody tr.v-data-table__selected {
    background: #f5c17d70 !important;
  }
  .theme--dark.v-data-table tbody tr.v-data-table__selected {
    background: #a17b4970 !important;
  }
  .theme--dark.v-data-table tbody tr.v-data-table__selected:hover {
    background: #a17b49c2 !important;
  }
  .theme--light.v-data-table tbody tr.v-data-table__selected:hover {
    background: #ffd296d2 !important;
  }
  .btn-right-arrow {
    right: 0px;
    top: 100px;
  }
  .btn-left-arrow {
    left: 0px;
    top: 100px;
  }
  .apexcharts-tooltip {
    max-width: 70% !important;
  }
  .notation {
    white-space: pre-wrap !important;
  }
  .table-main-container .v-data-table__wrapper::-webkit-scrollbar {
    width: 3px;
    height: 10px;
    background-color: white;
  }
  .table-main-container .v-data-table__wrapper::-webkit-scrollbar-thumb,
  .table-main-container {
    background-color: #cacaca;
    scrollbar-color: #cacaca white;
  }
  .table-main-container .v-data-table__wrapper {
    scrollbar-width: thin;
  }
  .table-main-container .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
    background-color: #A8A8A8;
  }
</style>
